// For IE 11
import 'unfetch/polyfill'
import 'es6-promise/auto'

import { h, render } from 'preact'
import { AddressForm } from '@shopify/theme-addresses'
import 'regenerator-runtime/runtime'

import CartMonogram from './lib/cart-monogram'
import ProductMonogram from './lib/product-monogram'
import Modal from './lib/modal'
import ProductModal from './components/product-modal'
import UpsellMonogramInput from './components/upsell-monogram-input'
import FreeGiftSelection from './lib/free-gift-selection'

if (process.env.NODE_ENV === 'development') {
  require('preact/debug')
}

CartMonogram.initialize()

const monogram = new ProductMonogram()

function addMonogramIfNeeded (e) {
  const tags = e.detail.product.tags

  if (!tags.includes('Monogram') && !tags.includes('MonogramStraight')) return

  e.stopPropagation()

  const monogramInput = <UpsellMonogramInput monogramStraight={tags.includes('MonogramStraight')} callback={e.detail.callback} />

  const element = document.createElement('div')
  document.body.appendChild(element)
  render(h(ProductModal, { id: 'ask-for-monogram', product: e.detail.product, children: monogramInput }), element)
}

document.addEventListener('upsellselected', addMonogramIfNeeded, true)

document.addEventListener('DOMContentLoaded', () => {
  const freeGiftSelection = new FreeGiftSelection()
  freeGiftSelection.render()
})

export { monogram, AddressForm, Modal }
